import React from 'react';
import '../styles/Timeline.css';
import { useTranslations } from '../hooks/useTranslations';

export const yearsData = [
  { year: 2017, percentage: 90 },
  { year: 2018, percentage: 100 },
  { year: 2019, percentage: 89 },
  { year: 2020, percentage: 100 },
  { year: 2021, percentage: 100 },
  { year: 2023, percentage: 100 },
  { year: 2024, percentage: 75 },
  { year: 2025, percentage: 100 },
];

const Timeline = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="aikajana">
        <div className="aikajana-container">
          <span className="timeline-kicker">
            {t('timeline.kicker', 'Saavutuksemme vuodesta toiseen')}
          </span>
          <h1>{t('timeline.heading', 'Aikajanamme')}</h1>
          <p>{t('timeline.description', 'Tulokset puhuvat puolestaan – Super-Takuu kurssimme sisäänpääsyprosentit ovat vuodesta toiseen Suomen kovinta tasoa.')}</p>
          <div className="timeline">
            {yearsData.map(({ year: timelineYear, percentage: timelinePercentage }) => (
              <div className="timeline-item" key={`timeline-${timelineYear}`}>
                <div className="circle">
                  <span className="percentage">{timelinePercentage}%</span>
                </div>
                <span className="year">{timelineYear}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="aikajana-small">
        <div className="aikajana-container-small">
          <span className="timeline-kicker">
            {t('timeline.kicker', 'Saavutuksemme vuodesta toiseen')}
          </span>
          <h1>{t('timeline.heading', 'Aikajanamme')}</h1>
          <p>{t('timeline.description', 'Tulokset puhuvat puolestaan – Super-Takuu kurssimme sisäänpääsyprosentit ovat vuodesta toiseen Suomen kovinta tasoa.')}</p>
          <div className="timeline-small">
            <div
              className="timeline-scroll"
              role="list"
              aria-label={t('timeline.aria.list', 'Super-Takuu kurssin onnistumisprosentit')}
            >
              {yearsData.map(({ year: mobileYear, percentage: mobilePercentage }) => (
                <div
                  className="timeline-item-small"
                  key={`timeline-small-${mobileYear}`}
                  role="listitem"
                  aria-label={(() => {
                    const template = t(
                      'timeline.aria.item',
                      `Vuosi ${mobileYear}, ${mobilePercentage} prosenttia`
                    );
                    return template
                      .replace('{{year}}', mobileYear)
                      .replace('{{percentage}}', mobilePercentage);
                  })()}
                >
                  <div className="circle">
                    <span className="percentage">{mobilePercentage}%</span>
                  </div>
                  <span className="year">{mobileYear}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Timeline;
